import AttendanceAdapter from './base';

export default class Threshold extends AttendanceAdapter {
  modelNamePlural = 'thresholds';
}
